export const EXPRESSION_FIELD_STRINGS = {
  PLACEHOLDER: "Add expression",
  TAG_TOOLTIP: "This field is using a custom expression."
};

export const EXPRESSION_FIELD_TEST_IDS = {
  WRAPPER: "expression-field-wrapper",
  ICON: "expression-field-icon"
};
